import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler'; 
import { DecimalPipe } from '@angular/common';
import { SupplierAllotedAmtDetailsData, SupplierAllotedAmtDetails } from '../../../@core/interfaces/pharmacy/SupplierAllotedAmtDetails';
import { SupplierPaymentDetailsData, SupplierPaymentDetails } from '../../../@core/interfaces/pharmacy/SupplierPaymnetDetails';

export interface SupplierBillMasterParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface SupplierBillMaster { 

    id ?: number;
    paymentDate:any;
    receiverType:string;
    expenseType:string;
    employeeId:string;
    supplierId :string;
    supplierName :string;
    physicianId :string;
    expenseId :string;
    notes :string;
    othersName :string;
    othersAddress  :string;
    othersPhone  :string;
    expenseNo  :string;
    netAmount :number;
    paidAmount:number;
    branchId: string;
    tenantId: string;  
    paymentsDet: SupplierPaymentDetails[];
    phSupPayments: SupplierAllotedAmtDetails[];
    pharmacyId:number;

    parameters?: SupplierBillMasterParameter[];
    links?: any;
    createdBy?: number | string,
    createdDate?: Date,
    updatedBy?: number | string,
    updatedDate?: Date,
    createdIp?: string,
    updatedIp?: string,
}


export abstract class SupplierBillMasterData {
    abstract getall(url: string): Observable<SupplierBillMaster[]>;
    abstract getById(url: string): Observable<any>;
    abstract list(url: string): Observable<any>; 
    abstract create(url: string, data: SupplierBillMaster): Observable<SupplierBillMaster[]>;
    abstract searchList(url: string,data:any): Observable<any>;
    abstract createInvSupp(url: string, data: any): Observable<any>;
}
